module.exports = __webpack_public_path__ + "static/img/about041.77ba3c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about041.png
// module id = Uy0J
// module chunks = 1